import React from "react";
import { Link } from "react-router-dom";
import "./InnerHeader.scss";

function InnerHeader(props) {
    
    // Normalize and map special cases for comparison
    const getNormalizedPath = () => {
        let path = window.location.pathname.split('/')[1]?.toLowerCase().replace(/\s+/g, "");
        if (path === "dagsevent") path = "pakontoret";
        if (path === "julebord") path = "firmafest";
        return path;
    };

    const getNormalizedHeader = () => {
        let header = props?.HeaderHeading?.toLowerCase()?.replace(/\s+/g, "");
        if (!header) return "";
        if (header === "dagsevent") header = "pakontoret";
        if (header === "julebord") header = "firmafest";
        return header;
    };

    const path = getNormalizedPath();
    const header = getNormalizedHeader();

    const shouldShowHeader =
        path === header ||
        path === "aktiviteter" ||
        path === "bestilt-aktivitet";

    return (
        <>
            {shouldShowHeader && (
                <div className="container">
                    <div className="inner_header_main">
                        <div className="header_wrapper">
                            <span
                                dangerouslySetInnerHTML={{
                                    __html: props?.HeaderHeading
                                        ?.replace("Dagsevent", "På kontoret")
                                        ?.replace("Julebord", "Firmafest")
                                        ?.replace("pakontoret", "På kontoret") 
                                }}
                            />
                            {props?.qty ? ` (${props.qty})` : ""}
                            {/* 
                            {props.hideHome !== true && (
                                <p className="heading-m header_desc_link">
                                    <span>{props.PageText}</span>
                                    |
                                    <Link to="/" className="linkk_home">
                                        {" "}
                                        Home
                                    </Link>
                                </p>
                            )} 
                            */}
                        </div>
                    </div>
                </div>
            )}
        </>
    );
}

export default InnerHeader;